import { makeObservable } from 'mobx';

import { LegalEntityPriceListData } from 'chaika-frontend-types/frontend-cms';

import { LongList } from '@store/abstract/LongList';
import {
    calculateLegalEntityPriceStatus,
    LegalEntityPriceListWithStatusData,
    LegalEntityPriceStatus,
} from '@price/utils/legalEntityPriceListStatus';

export interface LegalEntityPriceListFilterParams {
    status?: LegalEntityPriceStatus[];
    name?: string;
}

export class LegalEntityPriceList extends LongList<
    LegalEntityPriceListWithStatusData,
    LegalEntityPriceListData,
    LegalEntityPriceListFilterParams
> {
    public static Name = 'legalEntityPriceList' as const;

    constructor(params?: LegalEntityPriceListData[]) {
        super(params);
        makeObservable(this);
    }

    protected create(params: LegalEntityPriceListData): LegalEntityPriceListWithStatusData {
        return { ...params, status: calculateLegalEntityPriceStatus(params) };
    }

    protected filterValue(
        value: LegalEntityPriceListWithStatusData,
        { name, status }: LegalEntityPriceListFilterParams,
    ): boolean {
        return (
            this.filterFieldValueByArray(value, status, 'status') &&
            this.filterFieldValueIncludesString(value, name, 'name')
        );
    }
}

export const legalEntityPriceList = new LegalEntityPriceList();
